import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  TEACHERS_BULK_UPLOAD_WORK_UPLOAD_AND_QR_URL,
  TEACHERS_HOME_URL
} from 'config/urls';

import { ReactComponent as AddIcon } from 'pages/Teachers/Home/assets/add-icon.svg';
import { ReactComponent as DocumentIcon } from 'pages/Teachers/Home/assets/document-icon.svg';
import { trackMixpanelEvent } from 'utils/integrations/mixpanel';
import { reverse } from 'utils/urls';

import styles from './styles.module.scss';

const DashboardHeader = ({ userId, handleCreateAssignment }) => {
  const history = useHistory();

  const handleUploadAssignment = () => {
    trackMixpanelEvent(userId, 'Upload Student Works Button Clicked.', {
      feature: 'home page',
      view: 'home page',
      normalizedURL: process.env.REACT_APP_BASE_FRONTEND_URL + TEACHERS_HOME_URL
    });

    history.push({
      pathname: reverse(TEACHERS_BULK_UPLOAD_WORK_UPLOAD_AND_QR_URL)
    });
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerActions}>
        <button className={styles.iconBtn} onClick={handleUploadAssignment}>
          <DocumentIcon />
        </button>
        <button onClick={handleCreateAssignment} className={styles.createBtn}>
          <span className={styles.addIconWrapper}>
            <AddIcon />
          </span>
          <span>Create Assignment</span>
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;
